<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">{{ $t('pmsH') }}</h1>
        <p style="color: white; padding-top: 10px;">{{ $t('pmsP') }}</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div class="row">
            <div class="col-xl-4 col-md-4 col-sm-12 pl-0 pr-0 ml-3 mr-3 mt-3" style="border: 1px solid #f2f2f2;">
                <b-img src="@/assets/PMS/om1.jpg" fluid alt="Responsive image"></b-img>
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'CloudPms', params: {}}">
                    <h4 class="p-3" style="">{{ $t('pmsServ1') }}</h4>
                    <p class="ml-3 underline">{{ $t('pmsDetail') }}</p>
                </router-link>
            </div>
            <div class="col-xl-4 col-md-4 col-sm-12 pl-0 pr-0 ml-3 mr-3 mt-3" style="border: 1px solid #f2f2f2;">
                <b-img src="@/assets/PMS/om2.jpg" fluid alt="Responsive image"></b-img>
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'ServerBasedPms', params: {}}">
                    <h4 class="p-3" style="">{{ $t('pmsServ2') }}</h4>
                    <p class="ml-3 underline">{{ $t('pmsDetail') }}</p>
                </router-link>
            </div>
        </div>
    </div>
</div> 
</template>

<script>

export default {
  name: 'PmLanding',
  metaInfo: {
    title: 'Property Management',
  },
  data(){
      return{
       
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
